import { clone, range, is, map, gt, lt } from 'ramda'
import { TIPO_PERSONA_MORAL } from './constants'

import moment from 'moment'
const avoidNames = [
  ' ABP',
  ' AC',
  ' AR',
  ' ARIC DE RL DE CV',
  ' IAP',
  ' S DE RL',
  ' S DE RL DE CV',
  ' S DE RL MI',
  ' S EN NC',
  ' SA',
  ' SA DE CV',
  ' SA DE CV SOFOM ENR',
  ' SA DE CV SOFOM ER',
  ' SA DE RL DE CV',
  ' SA INSTITUCIÓN DE BANCA MÚLTIPLE',
  ' SAB DE CV',
  ' SAPI DE CV',
  ' SAPI DE CV SOFOM ENR',
  ' SAS',
  ' SAS DE CV',
  ' SC',
  ' SC DE AP DE RL',
  ' SC DE AP DE RL DE CV',
  ' SC DE RL',
  ' SC DE RL DE CV',
  ' SPR DE RL',
  ' SPR DE RL DE CV'
];

const validateName = (str: string): boolean => {
  const lowerCaseStr = str.replace(/[.,]/g, '').toLowerCase();
  return !avoidNames.some(name => lowerCaseStr.endsWith(name.toLowerCase()));
};

export const validateData = (data: any) => {
  const fields = Object.keys(data);
  const dataWithErrors: any = {};
  const result = fields.map(field => {
    if (data[field].validation) {
      const valid = validator(data[field].value, data[field].validation, data);
      dataWithErrors[field] = { ...data[field], ...valid }
      return valid
    }
    dataWithErrors[field] = { ...data[field], valid: true }
    return { valid: true }
  })

  return { data: dataWithErrors, hasErrors: !result.every(it => it.valid) }
}

export const validator: any = (value: string, rules: string, data: any) => {
  const rulesArr = rules.split('|')
  const errors = rulesArr.map(rule => {
  const ruleWithParams: Array<string> = rule.split(':')

    return {
      rule: ruleWithParams[0],
      ...rulesDef[ruleWithParams[0]](value, ruleWithParams.length ?
        ruleWithParams[1] : undefined, data)
    }
  })

  return { valid: errors.every(it => it.valid), errors: errors.filter(it => !it.valid) }
}

const rulesDef: any = {
  number: (value: number) => {

    return { valid: !isNaN(value), message: '¡El valor no és un número!' }
  },
  required: (value: string) => {
    const val = `${value}`

    return { valid: !!val, message: '¡El valor es requerido!' }
  },
  isLength: (value: string, param: string) => {
    if (!param) {
      return true
    }

    return {
      valid: value ? (value.length === +param) : true,
      message: `¡El texto debe ser de ${param} caracteres!`
    }
  },
  minLength: (value: string, param: string) => {
    if (!param) {
      return true
    }

    return {
      valid: value ? (value.length >= +param) : true,
      message: `¡El texto debe tener una longitud mínima de ${param} caracteres!`
    }
  },
  match: (value: string, param: string, data: any) => {

    return { valid: value === data[param].value, message: `¡Los valores ingresados no coinciden!` }
  },
  requiredIfCustom: (value: string, param: string, data: any) => {
    const { depends, dependsValue } = data[param]
    const { value: toValidate } = data[depends]
    const valid = dependsValue === toValidate ? !!value : true

    return { valid, message: '¡El valor es requerido!' }
  },
  requiredIfNotCustom: (value: string, param: string, data: any) => {
    const { depends, dependsValue } = data[param]
    const { value: toValidate } = data[depends]
    const valid = dependsValue !== toValidate ? !!value : true

    return { valid, message: '¡El valor es requerido!' }
  },
  requiredIf: (value: string, param: string, data: any) => {

    return { valid: data[param].value ? !!value : true, message: 'El valor es requerido' }
  },
  uploadedIf: (value: string, param: string, data: any) => {

    return { valid: data[param].value ? !!value : true, message: '¡Favor de confirmar que el archivo haya sido cargado!' }
  },
  email: (value: string) => {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return { valid: emailRegex.test(value), message: '¡El valor debe ser un correo electrónico válido!' }
  },
  rfc: (value = '', param: string, data: any) => {
    let letters, digits
    const regexLetters = /^[a-zA-Z]*$/
    let validLength = false;
    if (param && +data[param].value === TIPO_PERSONA_MORAL) {
      letters = value.substr(0, 3)
      digits = value.substr(3, 6)
      validLength = value.length === 12
    } else {
      letters = value.substr(0, 4)
      digits = value.substr(4, 6)
      validLength = value.length === 13

    }

    const isValid = regexLetters.test(letters) && !isNaN(+digits) && validLength

    return { valid: isValid, message: '¡El valor del rfc es incorrecto!' }
  },
  greaterThan: (value: string, param: string) => {
    return { valid: gt(+value, +param), message: `El valor debe ser mayor que ${param}` }
  },
  lessThan: (value: string, param: string) => {
    return { valid: lt(+value, +param), message: `El valor debe ser menor que ${param}` }
  },
  greaterThanDate: (value: string, param: string) => {
    const valueDate = moment(value).format('YYYY-MM-DD');
    const paramDate = moment(param).format('YYYY-MM-DD');
    const isValid = valueDate > paramDate;
    return { valid: isValid, message: `La fecha debe ser mayor a ${moment(param).format('DD/MM/YYYY')}` }
  },
  gtOrEqDate: (value: string, param: string) => {
    const valueDate = moment(value).format('YYYY-MM-DD');
    const paramDate = moment(param).format('YYYY-MM-DD');
    const isValid = valueDate >= paramDate;
    return { valid: isValid, message: `La fecha debe ser mayor o igual a ${moment(param).format('DD/MM/YYYY')}` }
  },
    isValidName: (value: string) => {

    return { valid: validateName(value), message: 'La Razon Social no debe contener el Régimen Societario' }
  },
}

const transformDef: any = {
  stringToBool: (value: string) => {

    return value === 'true' ? true : false;
  },
  stringToNumber: (value: string) => {

    return !value ? 0 : +value
  },
}

export const getValues = (data: any) => {
  let extractedValues: any = {}

  Object.keys(data).forEach(it => {
    if (data[it].same) {
      extractedValues[it] = data[data[it].same].value
    } else if (data[it].dataMarshaller) {
      extractedValues[it] = data[it].dataMarshaller(data[it].value)
    } else {
      extractedValues[it] = data[it].value
    }
  })
  return extractedValues
}

export const getDataInput = ({ name, value, type, checked, ...rest } : { name: string, value: string, type: string, checked: boolean }, data: any) => {
  let validateField = true
  let values = clone(data)
  let transformed;
  const fieldValue = (type === 'checkbox') ? checked : value

  validateField = data[name].pattern ? validator(fieldValue, data[name].pattern).valid : true
  transformed = data[name].transform ? transformDef[data[name].transform](fieldValue) : fieldValue
  values[name].value = validateField ? transformed : data[name].value

  return values
}

export const mapPropsToState = (state: any, ownProps: any) => {
  const fields = Object.keys(state)
  const data = clone(state)

  fields.forEach(it => {
    if (ownProps.hasOwnProperty(it)) {
      data[it].value = data[it].dataUnmarshaller ? data[it].dataUnmarshaller(ownProps[it]) : ownProps[it]
    }
  })

  return data
}

export const getLastyears = (lastYears: number) => {
  const currYear = new Date().getFullYear();
  const rangeYears = range((currYear - lastYears), currYear);

  return rangeYears.map(year => ({ value: year, label: year }));
}

export const getClabeData = (clabe = '') => {
  const bank = clabe.substr(1, 3)
  const place = clabe.substr(4, 3)
  const account = clabe.substr(6, 11)
  return { bank, place, account }
}

export const transformData = (cmd: any, data: any) => {
  return map(transformer => {
    return is(Function, transformer) ? transformer(data) : transformer
  })(cmd)
}

